import { useQuery } from "@tanstack/react-query";
import { submissionService } from "@/services/submissionService";

export const submissionKeys = {
  all: ['submissions'],
  list: (page, searchParams) => [...submissionKeys.all, 'list', page, searchParams],
};

// Hook for fetching user submissions with pagination and search
export const useSubmissions = (page = 1, searchParams = {}) => {
  return useQuery({
    queryKey: submissionKeys.list(page, searchParams),
    queryFn: async () => {
      const response = await submissionService.getUserSubmissions(page, searchParams);
      
      return {
        data: response?.data || [],
        pagination: {
          current_page: response?.pagination?.current_page || 1,
          total: response?.pagination?.total || 0,
          per_page: response?.pagination?.per_page || 10,
          last_page: response?.pagination?.last_page || 1
        }
      };
    },
    keepPreviousData: true // Keep displaying previous data while new data is fetched
  });
}; 